/**
 * A URL without its query string or fragment, for anything that leaves the
 * cluster (Faro telemetry, PostHog analytics). Both can carry credentials: a
 * one-time token (`/set-password?token=`) or a session (`/impersonate/land#s=`).
 * The path is what analytics and debugging need.
 */
export function stripQueryAndHash(url: string): string {
  const end = url.search(/[?#]/)
  return end === -1 ? url : url.slice(0, end)
}
